const baseStyle = {
    color: "font.primary",
};
const variantNormal = {
    fontSize: "sm",
    fontWeight: "medium",
    lineHeight: "base",
};
const variantSmall = {
    fontSize: "xs",
    fontWeight: "medium",
    lineHeight: "base",
};
const variantMuted = {
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "base",
};
const variantCapitals = {
    fontSize: "xs",
    fontWeight: "medium",
    lineHeight: "base",
    textTransform: "uppercase",
};
const variantSmallMuted = {
    fontSize: "xs",
    fontWeight: "normal",
    lineHeight: "base",
};
const variantSmallCapitals = {
    fontSize: "10px",
    fontWeight: "medium",
    lineHeight: "base",
    textTransform: "uppercase",
};
const variants = {
    normal: variantNormal,
    small: variantSmall,
    capitals: variantCapitals,
    muted: variantMuted,
    smallMuted: variantSmallMuted,
    smallCapitals: variantSmallCapitals,
};
const defaultProps = {
    variant: "normal",
};
const FormLabel = {
    baseStyle,
    variants,
    defaultProps,
};
export default FormLabel;
